export function readLanguageQuery(supported, search = window.location.search) {
  const language = new URLSearchParams(search).get('lang');
  return supported.includes(language) ? language : null;
}

export function updateLanguageQuery(language) {
  const url = new URL(window.location.href);
  if (!url.searchParams.has('lang')) return;
  url.searchParams.set('lang', language);
  window.history.replaceState(window.history.state, '', `${url.pathname}${url.search}${url.hash}`);
}
